// Report.js
import React from 'react';
import { useParams } from 'react-router-dom';

function Report({ reportsData }) {
    // Get the reportId from the URL parameters
    const { reportId } = useParams();

    // Find the report in the reportsData array based on the reportId
    // const report = reportsData.find(rs => r.id === parseInt(reportId));

    // Handle case where report is not found (e.g., invalid ID in URL)
    // if (!report) {
    //     return <div>Report not found.</div>;
    // }

    return (
        // <div className='about-page'>
        <header className='height-75'>
            <div className='container h-100 d-flex flex-column align-items-center justify-content-center text-light'>
                <h1 className='text-center fw-semibold'>{reportId}</h1>

            </div>
        </header>
        // </div>
    );
}

export default Report;